import { isDate, isString } from './base';

var _d = new Date();

var date = {
  /**
  * 获取日期
  * @param {string} sep 分隔符 默认为-
  * @return {string} yyyy-mm-dd
  */
  toDateString: function toDateString(nd) {
    var a = [];
    var dt = isDate(nd) ? nd : _d;
    var m = dt.getMonth() + 1;
    var d = dt.getDate();
    var sep = arguments[1] ? arguments[1] : isString(arguments[0]) ? arguments[0] : '-';
    a.push(dt.getFullYear());
    a.push(m.toString().length < 2 ? "0".concat(m) : m);
    a.push(d.toString().length < 2 ? "0".concat(d) : d);
    return a.join(sep);
  },

  /**
  * 获取日期和时间
  * @param {string} sep 分隔符 默认为-
  * @return {string} yyyy-mm-dd hh:ii:ss
  */
  toDateTimeString: function toDateTimeString(nd) {
    var dt = isDate(nd) ? nd : _d;
    var h = dt.getHours();
    var i = dt.getMinutes();
    var s = dt.getSeconds();
    var a = [];
    a.push(h.toString().length < 2 ? "0".concat(h) : h);
    a.push(i.toString().length < 2 ? "0".concat(i) : i);
    a.push(s.toString().length < 2 ? "0".concat(s) : s);
    return "".concat(date.toDateString.apply(this, arguments), " ").concat(a.join(':'));
  },

  /**
  * 是否润年
  * @param {int} year 年份
  * @return {bool} 是/否
  */
  isLeapYear: function isLeapYear(year) {
    return 0 == year % 4 && (year % 100 != 0 || year % 400 == 0);
  },

  /**
  * 获取服务器时间
  * @return {date} Date
  */
  getSeverDateTime: function getSeverDateTime() {
    var xhr = window.ActiveXObject ? new ActiveXObject('Microsoft.XMLHTTP') : new XMLHttpRequest();
    xhr.open('HEAD', window.location.href, false);
    xhr.send();
    var d = new Date(xhr.getResponseHeader('Date'));
    return d;
  }
};
export default date;